import { ApiFavorite } from "@/api/favorite";
import { useSearchParams } from "next/navigation";
import { useStore } from "@/hooks/system/useStore";
import { useEffect } from "react";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useFavoritesData = () => {
  const searchParams = useSearchParams();

  const { setSelectedFilters, selectedFilters } = useStore("favorite");

  useEffect(() => {
    const page_number = searchParams.get("page_number");

    setSelectedFilters({
      pageNumber: page_number ? +page_number : 1,
    });
  }, [searchParams, selectedFilters.productGuids, setSelectedFilters]);
  const { data: favorites, isLoading } = useLocalizedQuery({
    queryKey: ["favorites", selectedFilters.pageNumber, selectedFilters.productGuids],
    queryFn: async lang =>
      ApiFavorite.getFavorites(
        {
          pageNumber: selectedFilters.pageNumber,
          pageSize: 12,
          productGuids: selectedFilters.productGuids,
        },
        lang,
      ),
    options: {
      enabled: selectedFilters.productGuids.length > 0,
      placeholderData: prev => prev,
    },
  });

  return { favorites, isLoading };
};
